const formatPhoneNumber = (phoneNumber?: string) => {
  if (!phoneNumber) {
    return;
  }
  return phoneNumber.replace(/ /g, '');
};

export default formatPhoneNumber;
